<!-- 折线图 -->
<style lang="stylus" scoped>
.bar-wrap {
  height: 186px;
  width: 388px;
  background: url('../../../../static/img/industryInformation/line-bg1.png');
  background-position: 18% 50%;
  margin-left: 16px;
}

.line {
  height: 186px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <div class="bar-wrap">
    <div class="line">
      <div v-if="tit=='年平均昼夜温差'" class="main main1"></div>
      <div v-if="tit=='年平均降雨量'" class="main main2"></div>
      <div v-if="tit=='无霜期'" class="main main3"></div>
      <div v-if="tit=='年平均日照时长'" class="main main4"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  props: {
    tit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      myChart: {},
      colorList: {
        '年平均降雨量': new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#3CA6FF'
        }, {
          offset: 1,
          color: '#4451FF'
        }], false),
        '无霜期': new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#C4F4FA'
        }, {
          offset: 1,
          color: '#04CBE2'
        }], false),
        '年平均日照时长': new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
          offset: 0,
          color: '#F69211'
        }, {
          offset: 1,
          color: '#EC5D24'
        }], false)
      },
      dataList: {
        '年平均降雨量': [50, 40, 30, 20, 100, 150, 160, 180, 190, 100, 60, 20],
        '无霜期': [10, 12, 15, 20, 25, 30, 31, 31, 30, 20, 15, 20],
        '年平均日照时长': [7, 10, 10, 11, 12, 12, 12, 12, 11, 10, 9, 8]
      },
      unitList: {
        '年平均降雨量': 'ml',
        '无霜期': '天',
        '年平均日照时长': 'h'
      }
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    console.log(this.colorList[this.tit])
    // 基于准备好的dom，初始化echarts实例
    this.myChart2 = echarts.init(document.querySelector('.line .main2'));
    this.myChart3 = echarts.init(document.querySelector('.line .main3'));
    this.myChart4 = echarts.init(document.querySelector('.line .main4'));
    const option = {
      title: {
        text: this.tit,
        left: 'center',
        top: 10,
        textStyle: {
          color: '#fff'
        }
      },
      grid: { // 设置图表位置
        left: '15%',
        bottom: '15%',
        top: '22%'
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#243C7E",
            width: 1,
            type: "solid"
          }
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: "#77CAD8"
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#243C7E",
            width: 1,
            type: "solid"
          }
        },
        axisLabel: {
          show: true,
          formatter: "{value}" + this.unitList[this.tit],
          textStyle: {
            color: "#77CAD8"
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#4797FA",
            opacity: 0.3,
            width: 1,
            type: "solid"
          }
        }
      },
      series: [{
        data: this.dataList[this.tit],
        type: 'line',
        smooth: true,
        showSymbol: false,
        lineStyle: {
          normal: {
            width: 0
          }
        },
        areaStyle: {
          opacity: 1,
          normal: {
            color: this.colorList[this.tit]
          }
        },
        itemStyle: {
          normal: {
            color: '#f00'
          }
        }
      }]
    }
    if (this.tit === '年平均降雨量') {
      this.myChart2.setOption(option)
    } else if (this.tit === '无霜期') {
      this.myChart3.setOption(option)
    } else if (this.tit === '年平均日照时长') {
      this.myChart4.setOption(option)
    }

    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?540910ea